import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import * as moment from 'moment';

import {
  FieldMapItem,
  TableSettings,
  TableModeEnum,
  TableActionEnum,
  NotificationService,
  ModalService,
  ApplicationService,
} from 'beyond-util';

import { BackendService } from '../../../services/backend.service';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { SpiceEnum } from '../../../enums/spice.enum';
import { MontazaService } from '../../../services/montaza.service';
import {
  MONTAZA_RESETUJ_BLOKOVE,
  MONTAZA_DODAJ_U_NOVI_BLOK,
  MONTAZA_ULAZNA_SPICA,
  MONTAZA_IZLAZNA_SPICA,
  MONTAZA_UBACI_SPICE,
  MONTAZA_UBACI_U_SVE,
  MONTAZA_PROFILE,
  MONTAZA_VRATI_U_NULTI,
  MONTAZA_PROVERI,
  MONTAZA_OBRISI_BRENDIRANE_SPICE,
  MONTAZA_UBACI_BRENDIRANE_SPICE,
  MONTAZA_UBACI_BRENDIRANE_SPICE_U_BLOK,
  MONTAZA_OBRISI_BRENDIRANE_SPICE_U_BLOKU,
  MONTAZA_BRENDIRANE_SPICE,
  MONTAZA_UBACI_BSPICE_PO_AKCIJI,
} from '../../../constants/tooltip-messages';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnumService } from '../../../services/enum.service';

@Component({
  selector: 'app-montaza-details',
  templateUrl: './montaza-details.component.html',
})
export class MontazaDetailsComponent implements OnInit, OnDestroy {
  @Input() programFieldSettings: FieldMapItem;
  @Input() emisijaFieldSettings: FieldMapItem;
  @Input() datumFieldSettings: FieldMapItem;
  @Input() spotFieldSettings: FieldMapItem;
  @Input() spotFieldSettingsLessFilters: FieldMapItem;
  @Input() bilbordFieldSettings: FieldMapItem;
  @Input() blokFieldSettings: FieldMapItem;
  @Input() ugovorFieldSettings: FieldMapItem;
  @Input() brendSpicaFieldSettings: FieldMapItem;
  @Input() programi: any[];

  @Output() update: EventEmitter<any> = new EventEmitter<any>();
  @Output() fetchMontaza: EventEmitter<any> = new EventEmitter<any>();

  private _subscriptions: Subscription[] = [];

  public spotoviTableSettings: TableSettings;
  public blokoviTableSettings: TableSettings;

  public TableModeEnum = TableModeEnum;

  public blokovi: any[] = [];
  public selectedDatum: any;
  public selectedBlok: any;
  public selectedEmisija: any;
  public zapocetaMontaza = false;
  public selectedSpotovi: any[] = [];
  public selectedUlaznaSpica: any;
  public selectedIzlaznaSpica: any;
  public selectedUlaznaBrendiranaSpica: any;
  public selectedIzlaznaBrendiranaSpica: any;
  public selectedSpot: any;
  public selectedBilbord: any;
  public selectedUgovor: any;

  public trajanjeSekunde: number;

  public vremeProvere: any;
  public targetBlok: any;
  public vrsteSpota: any[] = [];

  private spotoviTableSettingsSource: Subject<any> = new Subject<any>();
  public spotoviTableSettings$ = this.spotoviTableSettingsSource.asObservable();

  private spotoviSource: Subject<any> = new Subject<any>();
  public spotovi$ = this.spotoviSource.asObservable();

  private _selectBlokSource = new Subject<any>();
  public selectBlok$ = this._selectBlokSource.asObservable();

  public readonly brendiraneSpiceActions = [
    'Ceo dan',
    'Blok',
    'Emisija',
    'Do kraja dana',
  ];

  public selectedBrendiranaSpicaAction: string;
  public showObrisiBrendiraneSpice = false;

  public tooltipOptions = {
    placement: 'top',
    'show-delay': '500',
    theme: 'light',
  };

  public tooltips = {
    MONTAZA_RESETUJ_BLOKOVE,
    MONTAZA_DODAJ_U_NOVI_BLOK,
    MONTAZA_ULAZNA_SPICA,
    MONTAZA_IZLAZNA_SPICA,
    MONTAZA_UBACI_SPICE,
    MONTAZA_UBACI_U_SVE,
    MONTAZA_PROFILE,
    MONTAZA_VRATI_U_NULTI,
    MONTAZA_PROVERI,
    MONTAZA_OBRISI_BRENDIRANE_SPICE,
    MONTAZA_UBACI_BRENDIRANE_SPICE,
    MONTAZA_UBACI_BRENDIRANE_SPICE_U_BLOK,
    MONTAZA_OBRISI_BRENDIRANE_SPICE_U_BLOKU,
    MONTAZA_BRENDIRANE_SPICE,
    MONTAZA_UBACI_BSPICE_PO_AKCIJI,
  };

  /**
   * Proverava postojanje brendiranih spica na razlicitim nivoima
   * i postavlja showObrisiBrendiraneSpice na true/false
   * u zavisnosti da li dugme za brisanje brendiranih spica treba da
   * bude vidljivo ili ne.
   *
   * @param {string} checkType - Nivo akcije za brisanje brendiranih spica ('Ceo dan', 'Blok', 'Emisija', 'Do kraja dana')
   */
  public brendiraneSpicePostoje(checkType: string) {
    switch (checkType) {
      // Ceo dan
      case this.brendiraneSpiceActions[0]: {
        if (
          this._montazaService.montaza.Blokovi.some(blok =>
            blok.ElementiBloka.some(
              element => element.Sadrzaj.VrstaSpotaId === 9
            )
          )
        ) {
          this.showObrisiBrendiraneSpice = true;
        } else {
          this.showObrisiBrendiraneSpice = false;
        }
        break;
      }
      // Blok
      case this.brendiraneSpiceActions[1]: {
        if (
          this.selectedBlok.ElementiBloka.some(
            element => element.Sadrzaj.VrstaSpotaId === 9
          )
        ) {
          this.showObrisiBrendiraneSpice = true;
        } else {
          this.showObrisiBrendiraneSpice = false;
        }
        break;
      }
      // Emisija
      case this.brendiraneSpiceActions[2]: {
        const blokoviEmisije = this._montazaService.montaza.Blokovi.filter(
          x => x.EmisijaRasporedId === this.selectedEmisija.Id
        );

        const elementiBlokova: any[] = new Array();
        blokoviEmisije.forEach(blok => {
          blok.ElementiBloka.forEach(element => {
            elementiBlokova.push(element);
          });
        });

        if (
          elementiBlokova.some(element => element.Sadrzaj.VrstaSpotaId === 9)
        ) {
          this.showObrisiBrendiraneSpice = true;
        } else {
          this.showObrisiBrendiraneSpice = false;
        }
        break;
      }
      // Do kraja dana
      case this.brendiraneSpiceActions[3]: {
        const emisijePosleIds = this.getTrailingEmisije(
          this._montazaService.montaza.EmisijaRasporedi,
          this.selectedEmisija.VremeEmitovanja
        );

        const blokoviEmisije = this._montazaService.montaza.Blokovi.filter(x =>
          emisijePosleIds.includes(x.EmisijaRasporedId)
        );

        const elementiBlokova: any[] = new Array();
        blokoviEmisije.forEach(blok => {
          blok.ElementiBloka.forEach(element => {
            elementiBlokova.push(element);
          });
        });

        if (
          elementiBlokova.some(element => element.Sadrzaj.VrstaSpotaId === 9)
        ) {
          this.showObrisiBrendiraneSpice = true;
        } else {
          this.showObrisiBrendiraneSpice = false;
        }
        break;
      }
    }
  }

  /**
   * Vraca niz ID-jeva emisija iz prosledjene liste koje selede posle vremena koje je prosledjeno
   * @param emisije - Lista emisija iz koje se vracaju sve koje slede posle nekog vremena
   * @param {string} startVreme - Vreme (HH:mm) koje predstavlja filter
   */
  private getTrailingEmisije(emisije: any[], startVreme: string) {
    const fromTime = moment(startVreme, 'HH:mm').valueOf();

    const emisijePosleIds: number[] = new Array();

    emisije.forEach(emisija => {
      if (moment(emisija.VremeEmitovanja, 'HH:mm').valueOf() >= fromTime) {
        emisijePosleIds.push(emisija.Id);
      }
    });

    return emisijePosleIds;
  }

  public onBrendiranaSpicaActionChange(event: any) {
    this.brendiraneSpicePostoje(this.selectedBrendiranaSpicaAction);
  }

  /**
   * Dodaje brendirane spice u zavisnosti od izabrane akcije u dropdown polju
   */
  public ubaciBrendiraneSpicePoAkciji() {
    switch (this.selectedBrendiranaSpicaAction) {
      // Ceo dan
      case this.brendiraneSpiceActions[0]: {
        this.ubaciBrendiranuSpicu();
        break;
      }
      // Blok
      case this.brendiraneSpiceActions[1]: {
        this.ubaciBrendiranuSpicuUBlok();
        break;
      }
      // Emisija
      case this.brendiraneSpiceActions[2]: {
        this.ubaciBrendiranuSpicuUEmisiju();
        break;
      }
      // Do kraja dana
      case this.brendiraneSpiceActions[3]: {
        this.ubaciBrendiranuSpicuDoKrajaDana();
        break;
      }
    }
  }

  public obrisiBrendiraneSpicePoAkciji() {
    switch (this.selectedBrendiranaSpicaAction) {
      // Ceo dan
      case this.brendiraneSpiceActions[0]: {
        this.obrisiBrendiraneSpice();
        break;
      }
      // Blok
      case this.brendiraneSpiceActions[1]: {
        this.obrisiBrendiraneSpiceIzBloka();
        break;
      }
      // Emisija
      case this.brendiraneSpiceActions[2]: {
        this.obrisiBrendiraneSpiceIzEmisije();
        break;
      }
      // Do kraja dana
      case this.brendiraneSpiceActions[3]: {
        this.obrisiBrendiraneSpiceDoKrajaDana();
        break;
      }
    }
  }

  get ukupnoTrajanje() {
    return this.selectedSpotovi && this.selectedSpotovi.length
      ? this.selectedSpotovi
          .filter(s => !s.Spica && !s.JeBilbord)
          .map(s => s.TrajanjeSekunde)
          .reduce((a, b) => a + b, 0)
      : 0;
  }

  get isNultiBlok(): boolean {
    return this.selectedBlok && this.selectedBlok.BrojBloka === 0;
  }

  get isEmisijaMontirana(): boolean {
    return this.selectedEmisija && this.selectedEmisija.Status === 2;
  }

  constructor(
    private _backendService: BackendService,
    private _notificationService: NotificationService,
    private _modalService: ModalService,
    private _montazaService: MontazaService,
    private _spinner: NgxSpinnerService,
    private _enumService: EnumService,
    private _applicationService: ApplicationService
  ) {}

  ngOnInit() {
    this.fetchMontazaSettings();
    this.subscribeToMontazaData();
    this.subscribeToEmisijaData();
    this.subscribeToPremestiEmisiju();
    this.subscribeToSacuvajMontazu();
    this.subscribeToVrstaSpota();
    this._enumService.fetchVrstaSpota();
  }

  ngOnDestroy() {
    this._montazaService.setIzvestajData(null);
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  subscribeToMontazaData() {
    this._subscriptions.push(
      this._montazaService.montazaData$.subscribe(data => {
        if (data) {
          this._montazaService.updateEmisija(
            data.ServiceData.EmisijaRasporedi[0]
          );
          this.setData(data.ServiceData, true, true);
        }
        this.zapocetaMontaza = true;
      })
    );
  }

  subscribeToPremestiEmisiju() {
    this._subscriptions.push(
      this._montazaService.premestiEmisiju$.subscribe(() => {
        this.resetMontaza();
      })
    );
  }

  subscribeToSacuvajMontazu() {
    this._subscriptions.push(
      this._montazaService.sacuvajMontazu$.subscribe(() => {
        this.resetMontaza();
      })
    );
  }

  subscribeToEmisijaData() {
    this._subscriptions.push(
      this._montazaService.emisijaData$.subscribe(data => {
        this.selectedEmisija = data;
        this.setData(this._montazaService.montaza, true, false);
        this.resetSpice();
        this.resetBrendiraneSpice();
        this.vremeProvere = null;
        this.selectedBrendiranaSpicaAction = '';
      })
    );
  }

  subscribeToVrstaSpota() {
    this._subscriptions.push(
      this._enumService.vrsteSpota$.subscribe(response => {
        this.vrsteSpota = response;
        this.setInitSpotoviSpiceFilter();
        this.setInitBilbordFilter();
      })
    );
  }

  fetchMontazaSettings() {
    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_MON,
      FormName.Montaza,
      EndpointTypes.GetAllEntities,
      null,
      null
    );
    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          const numField = response.Settings.details[0].allFields.find(
            field => field.name === 'UiRbr'
          );

          if (numField) {
            numField.width = 1;
            numField.sortable = false;
          }

          const spotoviTableSettings = new TableSettings(
            response.Settings.details[0],
            'table'
          );

          this.spotoviTableSettingsSource.next(spotoviTableSettings);
          this.spotoviSource.next([]);

          this.blokoviTableSettings = new TableSettings(
            response.Settings,
            'table'
          );
        })
    );
  }

  setInitSpotoviSpiceFilter() {
    const spicaId = this.getSpotIdByType('Špica');

    this.spotFieldSettings.lookupInitFilter = [
      { name: 'vrstaSpotaId', value: spicaId },
      { name: 'datumOdjaveOd', value: moment().format('YYYY-MM-DD') },
    ];

    this.spotFieldSettingsLessFilters.lookupInitFilter = [
      { name: 'vrstaSpotaId', value: spicaId },
      { name: 'datumOdjaveOd', value: moment().format('YYYY-MM-DD') },
    ];
  }

  setInitBilbordFilter() {
    const bilbordId = this.getSpotIdByType('Bilbordi');

    this.bilbordFieldSettings.lookupInitFilter = [
      { name: 'vrstaSpotaId', value: bilbordId },
      { name: 'datumOdjaveOd', value: moment().format('YYYY-MM-DD') },
    ];
  }

  setInitUgovorFilter() {
    this.ugovorFieldSettings.lookupInitFilter = [
      { name: 'spotId', value: this.selectedBilbord.Id },
    ];
  }

  getSpotIdByType(type: string) {
    return this.vrsteSpota.find(vs => vs.Naziv === type).Id;
  }

  setData(
    data: any,
    resetBlock: boolean = false,
    updateBlokovi: boolean = true
  ) {
    this._spinner.hide();

    if (updateBlokovi) {
      this._montazaService.updateBlokovi(data.Blokovi, this.selectedEmisija.Id);
    }

    const blokovi = data.Blokovi.map((b, index) => {
      const spotovi = b.ElementiBloka.map(e => {
        e.Sadrzaj.BrojElementa = e.BrojElementa;
        e.Sadrzaj.NazivElementa = e.NazivElementa;
        e.Sadrzaj.Aktivan = e.Aktivan;
        e.Sadrzaj.Modifikovano = this.selectedEmisija.Status === 2;
        e.Sadrzaj.color = e.Sadrzaj.JeBilbord ? 'warning' : e.Sadrzaj.color;
        e.Sadrzaj.color =
          e.Sadrzaj.VrstaSpotaId === 9 ? 'success-bright' : e.Sadrzaj.color;
        e.Sadrzaj.color = e.Aktivan ? e.Sadrzaj.color : 'disabled';

        return e.Sadrzaj;
      });
      this.refreshRbr(spotovi);

      return {
        Id: b.Id,
        MontazaId: b.MontazaId,
        BrojBloka: b.BrojBloka,
        DuzinaBloka: b.DuzinaBloka,
        EmisijaRasporedId: b.EmisijaRasporedId,
        BlokImaSpice: b.BlokImaSpice,
        Spotovi: spotovi,
        ElementiBloka: b.ElementiBloka,
        rbr: index,
      };
    });

    this.blokovi = blokovi.filter(
      b => b.EmisijaRasporedId === this.selectedEmisija.Id
    );

    this.selectedSpot = null;

    const selectedBlok = resetBlock
      ? this.blokovi[0]
      : this.blokovi.find(b => b.Id === this.selectedBlok.Id);
    this.spotoviSource.next(selectedBlok.Spotovi);
    setTimeout(() => {
      this._selectBlokSource.next(selectedBlok);
    }, 100);

    this.registerBlokoviEnum();
    this.selectedBlok = selectedBlok;
  }

  registerBlokoviEnum() {
    const brojeviBlokova = this.blokovi.map(b => {
      return {
        Naziv: b.BrojBloka.toString(),
        Id: b.Id,
      };
    });

    this._enumService.registerEnum(brojeviBlokova, 'MontazaBlokEnum');
  }

  dodaj(targetBlok?: boolean) {
    const selectedSpotovi = this.selectedSpotovi.filter(
      spot => !spot.Spica && !spot.JeBilbord
    );

    if (!selectedSpotovi.length) {
      this._notificationService.notyError(
        'Potrebno je izabrati rezervacije za dodavanje u novi blok.'
      );

      return;
    }

    if (this.isAllSelected(selectedSpotovi)) {
      this._notificationService.notyError(
        'Nije moguće prebaciti sve rezervacije u novi blok. Blok ne može ostati prazan.'
      );

      return;
    }

    if (
      targetBlok &&
      this.targetBlok &&
      this.targetBlok === this.selectedBlok.Id
    ) {
      this._notificationService.notyError(
        'Nije moguće prebaciti rezervacije u isti blok.'
      );

      return;
    }

    if (targetBlok && !this.targetBlok) {
      this._notificationService.notyError(
        'Niste izabrali blok u koji želite da prebacite izabrane rezervacije.'
      );

      return;
    }

    this._spinner.show();

    const elementiBloka = this.setElementiBloka(selectedSpotovi);

    const entity: any = {
      MontazaId: this.selectedBlok.MontazaId,
      EmisijaRasporedId: this.selectedBlok.EmisijaRasporedId,
      BrojBloka: this.selectedBlok.BrojBloka,
      DuzinaBloka: this.selectedBlok.DuzinaBloka,
      ElementiBloka: elementiBloka,
    };

    entity.TargetBlokId = targetBlok ? this.targetBlok : null;
    entity.Id = targetBlok ? this.selectedBlok.Id : null;
    entity.BrojSpotovaUBloku = targetBlok
      ? this.selectedBlok.Spotovi.filter(s => !s.Spica).length
      : null;

    const payload = this._backendService.getRequestPayload(
      targetBlok ? FormCode.MSMON_B2B : FormCode.MSMON_DBLK,
      FormName.Montaza,
      targetBlok ? EndpointTypes.PutEntity : EndpointTypes.PostEntity,
      null,
      entity
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => this.setData(response.ServiceData))
    );
  }

  isAllSelected(selectedSpotovi: any[]) {
    return (
      selectedSpotovi.length ===
      this.selectedBlok.Spotovi.filter(s => !s.Spica).length
    );
  }

  blokoviTableAction(event) {
    if (
      event.action === TableActionEnum.Select &&
      this.selectedBlok.Id !== event.document.Id
    ) {
      this.selectedBlok = event.document;
      this.selectedSpot = null;
      this.selectedSpotovi = [];
      this.spotoviSource.next(this.selectedBlok.Spotovi);
      this.selectedBrendiranaSpicaAction = '';
    }
  }

  spotoviTableAction(event) {
    if (event.action === TableActionEnum.Click) {
      this.selectedSpot = event.document;
      this.selectedSpotovi = event.selectedRows;
    }
  }

  onSelectedUlaznaSpicaChange(event) {
    if (event.value) {
      this.selectedUlaznaSpica = { ...event.value };
      this.selectedUlaznaSpica.Spica = SpiceEnum.Ulazna;
    }
  }

  onSelectedIzlaznaSpicaChange(event) {
    if (event.value) {
      this.selectedIzlaznaSpica = { ...event.value };
      this.selectedIzlaznaSpica.Spica = SpiceEnum.Izlazna;
    }
  }

  onBrendSpicaUlaznaChange(event) {
    if (event.value) {
      this.selectedUlaznaBrendiranaSpica = { ...event.value };
      this.selectedUlaznaBrendiranaSpica.Spica = SpiceEnum.Ulazna;
    }
  }

  onBrendSpicaIzlaznaChange(event) {
    if (event.value) {
      this.selectedIzlaznaBrendiranaSpica = { ...event.value };
      this.selectedIzlaznaBrendiranaSpica.Spica = SpiceEnum.Izlazna;
    }
  }

  onBilbordChange(event) {
    if (event.value) {
      this.selectedBilbord = event.value;
      this.selectedUgovor = null;
      this.setInitUgovorFilter();
    }
  }

  onUgovorChange(event) {
    if (event.value) {
      this.selectedUgovor = event.value;
    }
  }

  onBlokChange(event) {
    this.targetBlok = event.value;
  }

  ubaci() {
    if (!this.selectedBlok) {
      return;
    }

    if (!this.selectedUlaznaSpica || !this.selectedIzlaznaSpica) {
      this._notificationService.notyError(
        'Potrebno je izabrati ulaznu i izlaznu špicu.'
      );

      return;
    }

    this._spinner.show();
    this.mapSpicaPayload(this.selectedUlaznaSpica);
    this.mapSpicaPayload(this.selectedIzlaznaSpica);

    const sadrzaj = [this.selectedUlaznaSpica, this.selectedIzlaznaSpica];
    const elementiBloka = this.setElementiBloka(sadrzaj, true);

    const entity = {
      Id: this.selectedBlok.Id,
      MontazaId: this.selectedBlok.MontazaId,
      EmisijaRasporedId: this.selectedBlok.EmisijaRasporedId,
      BrojBloka: this.selectedBlok.BrojBloka,
      DuzinaBloka: this.selectedBlok.DuzinaBloka,
      ElementiBloka: elementiBloka,
    };

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_DSPI,
      FormName.Montaza,
      EndpointTypes.PostEntity,
      null,
      entity
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.setData(response.ServiceData);
          this.resetSpice();
        })
    );
  }

  ubaciUSveBlokove(allDay?: boolean) {
    if (!this.selectedUlaznaSpica || !this.selectedIzlaznaSpica) {
      this._notificationService.notyError(
        'Potrebno je izabrati ulaznu i izlaznu špicu.'
      );

      return;
    }

    const message = allDay
      ? 'Da li ste sigurni da želite da dodate odabrane špice na ceo dan?'
      : 'Da li ste sigurni da želite da dodate odabrane špice u sve blokove?';

    this._modalService.openModal(message, res => {
      if (res) {
        this.ubaciUSve(allDay);
      }
    });
  }

  ubaciUSve(allDay?: boolean) {
    this._spinner.show();
    this.mapSpicaPayload(this.selectedUlaznaSpica);
    this.mapSpicaPayload(this.selectedIzlaznaSpica);

    let filter = `?montazaId=${this._montazaService.montaza.Id}`;

    if (!allDay) {
      filter = `${filter}&emisijaRasporedId=${this.selectedEmisija.Id}`;
    }
    const entity = [this.selectedUlaznaSpica, this.selectedIzlaznaSpica];

    const payload = this._backendService.getRequestPayload(
      allDay ? FormCode.MSMON_SPNM : FormCode.MSMON_DSUM,
      FormName.Montaza,
      allDay ? EndpointTypes.PostEntity : EndpointTypes.PutEntity,
      filter,
      entity
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          if (allDay) {
            this._montazaService.updateSviBlokovi(response.ServiceData.Blokovi);
          }

          this.setData(response.ServiceData, !allDay);
          this.resetSpice();
        })
    );
  }

  obrisiBrendiraneSpiceIzEmisije() {
    this._spinner.show();
    const montazaId = this._montazaService.montaza.Id;
    const emisijaRasporedId = this.selectedEmisija.Id;

    const entityGuids = {
      MontazaId: montazaId,
      EmisijaRasporedId: emisijaRasporedId,
    };

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_OBSUE,
      FormName.Montaza,
      EndpointTypes.DeleteEntity,
      null,
      null,
      entityGuids
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.setData(response.ServiceData);
          this.resetBrendiraneSpice();
          this._montazaService.setMontaza(response.ServiceData);
          this.selectedBrendiranaSpicaAction = '';
        })
    );
  }

  ubaciBrendiranuSpicuUEmisiju() {
    if (
      !this.selectedUlaznaBrendiranaSpica ||
      !this.selectedIzlaznaBrendiranaSpica
    ) {
      this._notificationService.notyError(
        'Potrebno je izabrati ulaznu i izlaznu brendiranu špicu.'
      );

      return;
    }

    this._spinner.show();
    const filter = `?montazaId=${this._montazaService.montaza.Id}&emisijaRasporedId=${this.selectedEmisija.Id}`;
    const entity = [
      this.selectedUlaznaBrendiranaSpica,
      this.selectedIzlaznaBrendiranaSpica,
    ];

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_DBSUE,
      FormName.Montaza,
      EndpointTypes.PostEntity,
      filter,
      this._montazaService.mapBrendiraneSpiceToSadrzaj(entity, true)
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.setData(response.ServiceData);
          this.resetBrendiraneSpice();
          this._montazaService.setMontaza(response.ServiceData);
          this.selectedBrendiranaSpicaAction = '';
        })
    );
  }

  obrisiBrendiraneSpiceIzBloka() {
    this._spinner.show();
    const montazaId = this._montazaService.montaza.Id;
    const emisijaRasporedId = this.selectedEmisija.Id;
    const blokId = this.selectedBlok.Id;

    const entityGuids = {
      MontazaId: montazaId,
      EmisijaRasporedId: emisijaRasporedId,
      BlokId: blokId,
    };

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_OBSUB,
      FormName.Montaza,
      EndpointTypes.DeleteEntity,
      null,
      null,
      entityGuids
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.setData(response.ServiceData);
          this.resetBrendiraneSpice();
          this._montazaService.setMontaza(response.ServiceData);
          this.selectedBrendiranaSpicaAction = '';
        })
    );
  }

  obrisiBrendiraneSpice() {
    this._spinner.show();
    const montazaId = this._montazaService.montaza.Id;
    const entityGuids = {
      MontazaId: montazaId,
    };

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_OBSUM,
      FormName.Montaza,
      EndpointTypes.DeleteEntity,
      null,
      null,
      entityGuids
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.setData(response.ServiceData);
          this.resetBrendiraneSpice();
          this._montazaService.setMontaza(response.ServiceData);
          this.selectedBrendiranaSpicaAction = '';
        })
    );
  }

  obrisiBrendiraneSpiceDoKrajaDana() {
    this._spinner.show();
    const montazaId = this._montazaService.montaza.Id;
    const emisijaRasporedId = this.selectedEmisija.Id;
    const entityGuids = {
      MontazaId: montazaId,
      EmisijaRasporedId: emisijaRasporedId,
    };

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_OBSKD,
      FormName.Montaza,
      EndpointTypes.DeleteEntity,
      null,
      null,
      entityGuids
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.setData(response.ServiceData);
          this.resetBrendiraneSpice();
          this._montazaService.setMontaza(response.ServiceData);
          this.selectedBrendiranaSpicaAction = '';
        })
    );
  }

  ubaciBrendiranuSpicuDoKrajaDana() {
    if (
      !this.selectedUlaznaBrendiranaSpica ||
      !this.selectedIzlaznaBrendiranaSpica
    ) {
      this._notificationService.notyError(
        'Potrebno je izabrati ulaznu i izlaznu brendiranu špicu.'
      );

      return;
    }

    this._spinner.show();
    const filter = `?montazaId=${this._montazaService.montaza.Id}&emisijaRasporedId=${this.selectedEmisija.Id}`;
    const entity = [
      this.selectedUlaznaBrendiranaSpica,
      this.selectedIzlaznaBrendiranaSpica,
    ];

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_DBSKD,
      FormName.Montaza,
      EndpointTypes.PostEntity,
      filter,
      this._montazaService.mapBrendiraneSpiceToSadrzaj(entity, true)
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.setData(response.ServiceData);
          this.resetBrendiraneSpice();
          this._montazaService.setMontaza(response.ServiceData);
          this.selectedBrendiranaSpicaAction = '';
        })
    );
  }

  ubaciBrendiranuSpicuUBlok() {
    if (
      !this.selectedUlaznaBrendiranaSpica ||
      !this.selectedIzlaznaBrendiranaSpica
    ) {
      this._notificationService.notyError(
        'Potrebno je izabrati ulaznu i izlaznu brendiranu špicu.'
      );

      return;
    }

    this._spinner.show();
    const filter = `?montazaId=${this._montazaService.montaza.Id}&blokId=${this.selectedBlok.Id}&emisijaRasporedId=${this.selectedEmisija.Id}`;
    const entity = [
      this.selectedUlaznaBrendiranaSpica,
      this.selectedIzlaznaBrendiranaSpica,
    ];

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_DBSUB,
      FormName.Montaza,
      EndpointTypes.PostEntity,
      filter,
      this._montazaService.mapBrendiraneSpiceToSadrzaj(entity, true)
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.setData(response.ServiceData);
          this.resetBrendiraneSpice();
          this._montazaService.setMontaza(response.ServiceData);
          this.selectedBrendiranaSpicaAction = '';
        })
    );
  }

  ubaciBrendiranuSpicu() {
    if (
      !this.selectedUlaznaBrendiranaSpica ||
      !this.selectedIzlaznaBrendiranaSpica
    ) {
      this._notificationService.notyError(
        'Potrebno je izabrati ulaznu i izlaznu brendiranu špicu.'
      );

      return;
    }

    this._spinner.show();
    const filter = `?montazaId=${this._montazaService.montaza.Id}`;
    const entity = [
      this.selectedUlaznaBrendiranaSpica,
      this.selectedIzlaznaBrendiranaSpica,
    ];

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_DBSNM,
      FormName.Montaza,
      EndpointTypes.PostEntity,
      filter,
      this._montazaService.mapBrendiraneSpiceToSadrzaj(entity, true)
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.setData(response.ServiceData);
          this.resetBrendiraneSpice();
          this._montazaService.setMontaza(response.ServiceData);
          this.selectedBrendiranaSpicaAction = '';
        })
    );
  }

  ubaciBilbord() {
    if (!this.selectedBlok) {
      return;
    }

    if (!this.selectedBilbord) {
      this._notificationService.notyError('Potrebno je izabrati bilbord.');

      return;
    }

    if (!this.selectedUgovor) {
      this._notificationService.notyError(
        'Potrebno je izabrati ugovor za bilbord.'
      );

      return;
    }

    const blok = { ...this.selectedBlok };

    blok.ElementiBloka = this.setElementiBloka([this.selectedBilbord]);

    this.selectedBilbord.SpotId = this.selectedBilbord.Id;
    this.selectedBilbord.UgovorId = this.selectedUgovor.UgovorId;
    this.selectedBilbord.KlijentId = this.selectedUgovor.Klijent.Id;
    this.selectedBilbord.PodugovorId = this.selectedUgovor.Id;
    this.selectedBilbord.BrojUgovora = this.selectedUgovor.BrojUgovora;
    this.selectedBilbord.BrojPodugovora = this.selectedUgovor.BrojPodugovora;
    this.selectedBilbord.JeBilbord = true;
    delete this.selectedBilbord.Id;

    const montazaId = `montazaId=${this._montazaService.montaza.Id}`;
    const emisijaRasporedId = `emisijaRasporedId=${this.selectedEmisija.Id}`;
    const blokId = `blokId=${this.selectedBlok.Id}`;

    const filter = `?${montazaId}&${emisijaRasporedId}&${blokId}`;

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_DBB,
      FormName.Montaza,
      EndpointTypes.PostEntity,
      filter,
      blok
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this.resetBilbord();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this._montazaService.setMontaza(response.ServiceData);
          this.setData(response.ServiceData);
          this.resetBilbord();
        })
    );
  }

  resetBilbord() {
    this.selectedBilbord = null;
    this.selectedUgovor = null;
  }

  dodajPlaceholder() {
    const entity = {
      Id: this.selectedBlok.Id,
      MontazaId: this._montazaService.montaza.Id,
      EmisijaRasporedId: this.selectedEmisija.Id,
    };
    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_PLC,
      FormName.Montaza,
      EndpointTypes.PostEntity,
      null,
      entity
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.setData(response.ServiceData);
        })
    );
  }

  updateTrajanjeSekunde() {
    const spotovi = [...this.selectedSpotovi.filter(s => s.JePlaceholder)];

    if (!spotovi || !spotovi.length) {
      this._notificationService.notyError(
        'Niste izabrali placeholdere za koje želite da ažurirate trajanje.'
      );

      return;
    }

    if (!this.trajanjeSekunde) {
      this._notificationService.notyError(
        'Niste uneli trajanje za placeholdere.'
      );

      return;
    }

    spotovi.forEach(s => {
      s.TrajanjeSekunde = this.trajanjeSekunde;
    });

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_APLC,
      FormName.Montaza,
      EndpointTypes.PutEntity,
      `?montazaId=${this._montazaService.montaza.Id}`,
      spotovi
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this._notificationService.openNoty(
            'Uspešno ažurirano trajanje na izabranim placeholderima'
          );
          this.trajanjeSekunde = null;
          this.selectedSpotovi = [];
          this.setData(response.ServiceData);
        })
    );
  }

  toggleAktivan(row: any) {
    this._spinner.show();

    const entity = {
      Aktivan: row.Aktivan,
      BlokId: this.selectedBlok.Id,
      BrojElementa: row.BrojElementa,
      EmisijaRasporedId: this.selectedEmisija.Id,
      NazivElementa: row.NazivElementa,
      Sadrzaj: row,
      SadrzajId: row.Id,
    };

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_AAEL,
      FormName.Montaza,
      EndpointTypes.PutEntity,
      `?montazaId=${this._montazaService.montaza.Id}`,
      entity
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.setData(response.ServiceData);
        })
    );
  }

  mapSpicaPayload(spica) {
    spica.KlijentId = spica.Klijent.Id;
    spica.SpotId = spica.Id;
  }

  setElementiBloka(sadrzaj: any[], isSpica: boolean = false) {
    const elementiBloka = [];

    sadrzaj.forEach(s => {
      elementiBloka.push({
        BlokId: this.selectedBlok.Id,
        EmisijaRasporedId: this.selectedBlok.EmisijaRasporedId,
        Sadrzaj: s,
        SadrzajId: isSpica ? null : s.Id,
        BrojElementa: s.BrojElementa,
        NazivElementa: s.NazivElementa,
      });
    });

    return elementiBloka;
  }

  proveri() {
    this._spinner.show();

    const entity = {
      Spotovi: this.selectedBlok.Spotovi,
      MontazaId: this._montazaService.montaza.Id,
    };

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_PDCVS,
      FormName.Montaza,
      EndpointTypes.PostEntity,
      null,
      entity,
      null
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          this._spinner.hide();

          if (this._montazaService.hasError(response)) {
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          const data = response.ServiceData ? response.ServiceData : [];

          if (!Array.isArray(data)) {
            this._notificationService.notyError(data.Message);

            return;
          }

          this.selectedBlok.Spotovi.forEach(s => {
            const foundSpot = data.find(noviSpot => noviSpot.Id === s.Id);

            if (foundSpot) {
              s.JePrisutanNaVideoServeru = foundSpot.JePrisutanNaVideoServeru;
            }
          });

          this.spotoviSource.next(this.selectedBlok.Spotovi);
          this.fetchMontaza.next();
          this.osveziStanje();
        })
    );
  }

  osveziStanje() {
    this.vremeProvere = moment().format('DD.MM.YYYY. HH:mm:ss');
  }

  checkProfile() {
    let message =
      'Da li ste sigurni da želite da kreirate GRP za datu emisiju?';

    if (!this.hasSpice()) {
      message =
        'Špice nisu postavljene na sve blokove. Da li ste sigurni da želite da kreirate GRP za datu emisiju?';
    } else if (this.checkSpicePosition()) {
      message =
        'Neke od špica na blokovima nisu na prvom i poslednjem mestu, da li ste sigurni da želite da kreirate GRP za datu emisiju?';
    } else if (this.hasBilbordOnDifferentPosition()) {
      message =
        'U nekom bloku je dodat bilbord, ali se ne nalazi na poslednjem mestu, da li ste sigurni da želite da kreirate GRP za datu emisiju?';
    }

    this._modalService.openModal(message, res => {
      if (res) {
        this.profile();
      }
    });
  }

  checkSpicePosition() {
    return this.blokovi.some(b => {
      const spotovi = b.Spotovi;
      const poslednjiSpot = spotovi[b.Spotovi.length - 1];

      return (
        spotovi[0].Spica !== 'Ulazna' ||
        (poslednjiSpot.Spica !== 'Izlazna' && !poslednjiSpot.JeBilbord)
      );
    });
  }

  hasSpice() {
    return this.blokovi.some(b => {
      const found = b.Spotovi.find(s => s.Spica);

      return found;
    });
  }

  hasBilbordOnDifferentPosition() {
    return this.blokovi.some(b => {
      const spotovi = b.Spotovi;
      const found = spotovi.find(s => s.JeBilbord);
      const poslednjiSpot = spotovi[spotovi.length - 1];

      return found && found.Aktivan && !poslednjiSpot.JeBilbord;
    });
  }

  checkObrisi() {
    this._modalService.openModal(
      'Da li ste sigurni da želite da obrišete GRP fajlove?',
      res => {
        if (res) {
          this.profile(true);
        }
      }
    );
  }

  profile(obrisi?: boolean) {
    if (!this._montazaService.montaza || !this._montazaService.montaza.Id) {
      return;
    }

    this._spinner.show();

    const montaza = JSON.parse(JSON.stringify(this._montazaService.montaza));

    montaza.Blokovi = montaza.Blokovi.filter(
      b => b.EmisijaRasporedId === this.selectedEmisija.Id
    );
    montaza.EmisijaRasporedi = montaza.EmisijaRasporedi.filter(
      b => b.Id === this.selectedEmisija.Id
    );

    const filter = `?EmisijaRasporedId=${this.selectedEmisija.Id}`;

    const payload = this._backendService.getRequestPayload(
      obrisi ? FormCode.MSMON_DGRP : FormCode.MSMON_ZMON,
      FormName.Montaza,
      EndpointTypes.PutEntity,
      filter,
      montaza
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          this._spinner.hide();

          if (this._montazaService.hasError(response)) {
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          obrisi
            ? this._notificationService.openNoty(
                'GRP fajlovi su uspešno obrisani.'
              )
            : this._notificationService.openNoty(
                'Montaža uspešno završena, GRP fajlovi su uspešno kreirani.'
              );

          this.update.emit();
          this.selectedEmisija.Status = obrisi ? 1 : 2;
          this.setData(response.ServiceData);
        })
    );
  }

  resetujBlokove() {
    this._modalService.openModal('Da li želite da resetujete blokove?', res => {
      if (res) {
        this._spinner.show();
        const filter = `?MontazaId=${this._montazaService.montaza.Id}&EmisijaRasporedId=${this.selectedBlok.EmisijaRasporedId}`;
        const payload = this._backendService.getRequestPayload(
          FormCode.MSMON_RNNB,
          FormName.Montaza,
          EndpointTypes.PutEntity,
          filter,
          null
        );

        this._subscriptions.push(
          this._backendService
            .fetchMediaPlanSettings(payload)
            .subscribe((response: any) => {
              if (this._montazaService.hasError(response)) {
                this._spinner.hide();
                this._notificationService.notyError(
                  response['Errors'][0]['ErrorMessage']
                );

                return;
              }

              this.setData(response.ServiceData, true);
            })
        );
      }
    });
  }

  vratiUNultiBlok() {
    const selectedSpotovi = this.selectedSpotovi.filter(s => !s.Spica);

    if (!selectedSpotovi || !selectedSpotovi.length) {
      this._notificationService.notyError(
        'Niste izabrali rezervaciju koji želite da vratite u nulti blok.'
      );

      return;
    }

    this._spinner.show();

    const spotovi = this.mapElementiBloka(selectedSpotovi);
    const entity = spotovi[0]; // Za sad je vracanje samo jednog, bice promenjeno u vise.
    const filter = `?MontazaId=${this._montazaService.montaza.Id}`;
    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_SUNB,
      FormName.Montaza,
      EndpointTypes.PutEntity,
      filter,
      entity
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.setData(response.ServiceData, true);
        })
    );
  }

  mapElementiBloka(spotovi) {
    const elementiBloka = [];

    spotovi.forEach(s => {
      elementiBloka.push({
        BrojElementa: s.BrojElementa,
        BlokId: this.selectedBlok.Id,
        EmisijaRasporedId: this.selectedBlok.EmisijaRasporedId,
        SadrzajId: s.Id,
      });
    });

    return elementiBloka;
  }

  refreshRbr(elementiBloka) {
    let count = 1;
    elementiBloka.forEach(el => (el.UiRbr = count++));
  }

  resetMontaza() {
    this.zapocetaMontaza = false;
    this.selectedBlok = null;
    this.blokovi = [];
    this.spotoviSource.next([]);
  }

  resetSpice() {
    this.selectedUlaznaSpica = null;
    this.selectedIzlaznaSpica = null;
  }

  resetBrendiraneSpice() {
    this.selectedUlaznaBrendiranaSpica = null;
    this.selectedIzlaznaBrendiranaSpica = null;
  }

  orderedRowsChange(rows: any) {
    const entity = rows.map((r, i) => {
      return {
        Id: r.Id,
        Rbr: i + 1,
        JeSpica: r.JeSpica,
        Spica: r.Spica,
      };
    });

    const payload = this._backendService.getRequestPayload(
      FormCode.MSMON_RSDR,
      FormName.Montaza,
      EndpointTypes.PutEntity,
      `?montazaId=${this._montazaService.montaza.Id}&emisijaRasporedId=${this.selectedEmisija.Id}&blokId=${this.selectedBlok.Id}`,
      entity
    );

    this._subscriptions.push(
      this._backendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._spinner.hide();
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          this.setData(response.ServiceData);
        })
    );
  }

  otvoriIzvestaj() {
    this._montazaService.setIzvestajData({
      emisija: this.selectedEmisija,
      program: this.programi.find(p => p.Id === this._montazaService.programId),
      datum: this._montazaService.datum,
    });

    const tabToOpen = {
      Privileges: null,
      code: 'MSRR_REAL',
      name: 'OsnovniIzvestajRealizacije',
      text: 'Osnovni izveštaj realizacije',
      show: true,
    };

    this._applicationService.sidebarItemOpen(tabToOpen);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/montaza/montaza-details/montaza-details.component.ts